import React from 'react'
import { Card, Carousel, CarouselItem, Col, Row } from 'react-bootstrap'

const VirtualWorlds = () => {
  return (
    <>
         <Card className='no-border rounded-0 container virtual-worlds text-center'>
            <Card className='no-border rounded-0 virtual-worlds-child'>
                <Card.Title className='virtual-worlds-title'>Virtual Worlds</Card.Title>
                <Card.Text className='virtual-worlds-text'>
                Since 2020, our world has shifted even faster toward global connectivity where we can visit places, people, and events without leaving our homes. These experiences require the creation of virtual worlds for people to be transported via technology. 
                <br />
                <br /> Virtual worlds can mirror real places, combine realism and fantasy, or be created from scratch with elements that are impossible in the real world. They can be created t o show different periods in time — for example, students learning about Buddha’s birthplace in Nepal can virtually visit the historic site as it looks today, how it looked in 623 BC, and how it changed over time. 
                <br />
                <br /> Virtual worlds are the foundation of VR exp eriences — from gaming to education to business cases.
                </Card.Text>
            </Card>

            <Card className='no-border rounded-0 virtual-worlds-child virtual-world-bottom-section'>
                <Card.Title className='virtual-worlds-title'>Virtual Event Spaces Based in Reality: <br /> Tokushima Movie Festival</Card.Title>
                <Card.Text className='virtual-worlds-bottom-text'>
                The pandemic forced many events to go virtual. We built screening and event spaces for the Tokushima Movie Festival for an immersive attendee experience. We produced a VR version of the 3 - day festival in Microsoft’s AltspaceVR. In doing so, we created thre e venues: one for streaming films and movies, one for seminars, and one for esports. For one venue, we developed a recreation of the historic Yoriiza Theater, complete with 1929 company advertisements on the ceiling . For another outdoor space , we created almost a dozen other local buildings.
                </Card.Text>
            </Card>

            <Card className='no-border rounded-0 tokushima-movie-festival text-center'>
                <Carousel className='tokushima-carousel' interval={null} >
                    <CarouselItem>
                        <Row>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:1}}>
                                <Card className='no-border rounded-0 architectural-modeling-card p-2'>
                                    <Card.Img className='takushima-slider-images' src={process.env.PUBLIC_URL + "assets/digital-twin/tokushima/tokushima_001.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>Real Life<br /> Reference Photo</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:0}} className="tokushima-slider-right-image">
                                <Card className='no-border rounded-0 architectural-modeling-card p-2'>
                                    <Card.Img className='takushima-slider-images' src={process.env.PUBLIC_URL + "assets/digital-twin/tokushima/tokushima_001_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>Virtual Image Rendered <br /> From 3D Models</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </CarouselItem>
                    <CarouselItem>
                        <Row>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:1}}>
                                <Card className='no-border rounded-0 architectural-modeling-card p-2'>
                                    <Card.Img className='takushima-slider-images' src={process.env.PUBLIC_URL + "assets/digital-twin/tokushima/tokushima_002.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>Real Life<br /> Reference Photo</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:0}} className="tokushima-slider-right-image">
                                <Card className='no-border rounded-0 architectural-modeling-card p-2'>
                                    <Card.Img className='takushima-slider-images' src={process.env.PUBLIC_URL + "assets/digital-twin/tokushima/tokushima_002_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>Virtual Image Rendered <br /> From 3D Models</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </CarouselItem>
                    <CarouselItem>
                        <Row>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:1}}>
                                <Card className='no-border rounded-0 architectural-modeling-card p-2'>
                                    <Card.Img className='takushima-slider-images' src={process.env.PUBLIC_URL + "assets/digital-twin/tokushima/tokushima_003.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>Real Life<br /> Reference Photo</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:0}} className="tokushima-slider-right-image">
                                <Card className='no-border rounded-0 architectural-modeling-card p-2'>
                                    <Card.Img className='takushima-slider-images' src={process.env.PUBLIC_URL + "assets/digital-twin/tokushima/tokushima_003_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>Virtual Image Rendered <br /> From 3D Models</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </CarouselItem>
                    <CarouselItem>
                        <Row>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:1}}>
                                <Card className='no-border rounded-0 architectural-modeling-card p-2'>
                                    <Card.Img className='takushima-slider-images' src={process.env.PUBLIC_URL + "assets/digital-twin/tokushima/tokushima_004.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>Real Life<br /> Reference Photo</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:0}} className="tokushima-slider-right-image">
                                <Card className='no-border rounded-0 architectural-modeling-card p-2'>
                                    <Card.Img className='takushima-slider-images' src={process.env.PUBLIC_URL + "assets/digital-twin/tokushima/tokushima_004_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>Virtual Image Rendered <br /> From 3D Models</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </CarouselItem>
                    <CarouselItem>
                        <Row>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:1}}>
                                <Card className='no-border rounded-0 architectural-modeling-card p-2'>
                                    <Card.Img className='takushima-slider-images' src={process.env.PUBLIC_URL + "assets/digital-twin/tokushima/tokushima_005.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>Real Life<br /> Reference Photo</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:0}} className="tokushima-slider-right-image">
                                <Card className='no-border rounded-0 architectural-modeling-card p-2'>
                                    <Card.Img className='takushima-slider-images' src={process.env.PUBLIC_URL + "assets/digital-twin/tokushima/tokushima_005_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>Virtual Image Rendered <br /> From 3D Models</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </CarouselItem>
                    <CarouselItem>
                        <Row>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:1}}>
                                <Card className='no-border rounded-0 architectural-modeling-card p-2'>
                                    <Card.Img className='takushima-slider-images' src={process.env.PUBLIC_URL + "assets/digital-twin/tokushima/tokushima_006.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>Real Life<br /> Reference Photo</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:0}} className="tokushima-slider-right-image">
                                <Card className='no-border rounded-0 architectural-modeling-card p-2'>
                                    <Card.Img className='takushima-slider-images' src={process.env.PUBLIC_URL + "assets/digital-twin/tokushima/tokushima_006_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>Virtual Image Rendered <br /> From 3D Models</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </CarouselItem>
                    

                </Carousel>
            </Card>
            <Card className='no-border rounded-0 tokushima-video-section'>
                <Row>
                    <Col xs={{span:12, offset:0}} md={{span:8, offset:2}}>
                        <video className='tokushima-video-player container' muted loop autoPlay playsInline onContextMenu={(e) => e.preventDefault()}>
                            <source src={process.env.PUBLIC_URL + "assets/digital-twin/tokushima/video/Tokushima-Festival.mp4"} type="video/mp4"/>
                        </video>
                    </Col>
                </Row>

            </Card>

        </Card>
      
    </>
  )
}

export default VirtualWorlds
